module.exports = __webpack_public_path__ + "static/StaffAug-35542d9828ae1f48ce90ffd63fe8a656.png";